import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'leaflet/dist/leaflet.css'; // Import Leaflet CSS
//for-react-date-picker-CSS
import 'react-date-range/dist/styles.css'; // main css file
import "swiper/css";
import 'react-date-range/dist/theme/default.css'; 
import "bootstrap-icons/font/bootstrap-icons.css";

const App = lazy(() => import('./App'));
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HashRouter >
    <Provider store={store}>
      <Suspense fallback={
        <h1
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            height: '100vh',
          }}
        >Loading...
        </h1>
      }>
        <App />
      </Suspense>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light" />
    </Provider>
  </HashRouter>
);

